// 自动导入icons文件夹下面所有svg图标
const request = require.context('./svg', false, /\.svg$/);
request.keys().forEach(request);
